<template>
    <div class="raitingMovie" :class="class" @click="toggleRatingOpen">
        <div class="raitingMovie__container">
            <!-- <div class="title">
                Оцените
            </div> -->
            <div class="raitingMovie__wrapper" @click.stop>
                <ul
                    class="hero__ratings"
                    v-if="
                        movie?.rating.kinopoisk ||
                        movie?.average_customers_rating > 0 ||
                        movie?.rating?.imdb
                    "
                >
                    <li
                        class="hero__ratings_item"
                        v-if="movie?.rating?.kinopoisk"
                    >
                        <div class="hero__ratings_item_img">
                            <img
                                src="../../../assets/assets/Kinopoisk.svg"
                                alt="Tvcom"
                                loading="lazy"
                            />
                        </div>
                        <div class="hero__ratings_item_number">
                            {{ movie?.rating?.kinopoisk }}
                        </div>
                    </li>
                    <li class="hero__ratings_item" v-if="movie?.rating?.imdb">
                        <div class="hero__ratings_item_img">
                            <img
                                src="../../../assets/assets/IMDB.svg"
                                alt="Tvcom"
                                loading="lazy"
                            />
                        </div>
                        <div class="hero__ratings_item_number">
                            {{ movie?.rating?.imdb }}
                        </div>
                    </li>
                    <li
                        class="hero__ratings_item"
                        v-if="movie?.average_customers_rating > 0"
                    >
                        <div class="hero__ratings_item_img">
                            <img
                                src="../../../assets/assets/TVCOM_RATING.svg"
                                alt="Tvcom"
                                loading="lazy"
                            />
                        </div>
                        <div class="hero__ratings_item_number">
                            {{ movie?.average_customers_rating }}
                        </div>
                    </li>
                </ul>
                <div class="raitingMovie__wrapper_title">
                    <p>{{ $t("message.setRate") }}</p>
                    <span>{{ $t("message.setRateSubtitle") }}</span>
                </div>
                <div class="rating">
                    <div class="rating__wrapper">
                        <div
                            class="rating__list"
                            :class="{
                                notLoggedIn: !isLoggedIn,
                            }"
                        >
                            <template v-for="i in 10" :key="i">
                                <label
                                    :for="`rate-${unique}-${i}`"
                                    :style="{
                                        '--i': i,
                                    }"
                                    :data-i="i"
                                    @mouseenter="hoveredIndex = i"
                                    @mouseleave="hoveredIndex = null"
                                    @click="setRate(i)"
                                >
                                    <!-- <span v-if="rate < i">{{ i }}</span> -->
                                    <IRating
                                        :style="{
                                            transform:
                                                hoveredIndex === i
                                                    ? 'scale3d(1.35, 1.35, 1)'
                                                    : '',
                                            color:
                                                rate >= i && isLoggedIn
                                                    ? '#FFC700'
                                                    : '',
                                        }"
                                        :value="i"
                                    />
                                </label>
                                <input
                                    type="radio"
                                    name="rating"
                                    :id="`rate-${unique}-${i}`"
                                    :value="i"
                                    :aria-label="`Оценка ${i}`"
                                    v-model="rate"
                                />
                            </template>
                        </div>
                        <div class="rating__swiper">
                            <movieRatingSwiper
                                :customer_rating="customer_rating"
                                @setRating="setRating"
                            />
                            <div class="star"></div>
                        </div>
                        <!-- <button class="sendButton" @click="setRate(rate)">
                            {{ $t("message.sendRate") }}
                        </button> -->
                        <ElButton
                            size="medium"
                            type="default"
                            @click="setRate(rate)"
                        >
                            {{ $t("message.sendRate") }}
                        </ElButton>
                        <!-- <div class="rating__number">
                            <span>{{ rate < 0 ? 0 : rate }}.0</span>
                        </div> -->
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="thankForRate" :class="{ active: getIsMovieRatingSended }">
        <p>{{ $t("message.thanksForRate") }}</p>
    </div>
</template>

<script>
import IRating from "./IRating.vue";
import movieRatingSwiper from "./movieRatingSwiper.vue";
import ElButton from "../ElButton";
import { mapGetters } from "vuex";
export default {
    components: {
        IRating,
        movieRatingSwiper,
        ElButton,
    },
    props: ["class", "customer_rating", "movie", "isLoggedIn"],
    emits: ["openAuth", "toggleRatingOpen", "submitedRating"],
    data() {
        return {
            rate: 0,
            hoveredIndex: null,
            unique: new Date().getTime(),
        };
    },
    computed: {
        ...mapGetters(["getIsMovieRatingSended"]),
    },
    methods: {
        setRate(i) {
            if (!this.isLoggedIn) {
                this.toggleMOdalAuth();
                return;
            }
            this.submitRating(i);
        },
        setRating(value) {
            this.rate = value;
        },
        submitRating(i) {
            if (this.isLoggedIn) {
                this.$store.dispatch("setMovieRating", {
                    vid: this.$route.params.id,
                    rating: i,
                });
                this.toggleRatingOpen();
                this.$emit("submitedRating");
            }
        },
        toggleRatingOpen() {
            this.$emit("toggleRatingOpen");
        },
        toggleMOdalAuth() {
            this.rate = 0;
            this.$emit("openAuth");
        },
    },

    mounted() {
        if (!this.isLoggedIn) {
            return;
        }
        if (this.customer_rating) {
            this.rate = this.customer_rating;
        }
    },
};
</script>
<style lang="scss">
.raitingMovie {
    .rating {
        &__swiper {
            display: block;
            position: relative;
        }
    }
}
</style>
<style lang="scss" scoped>
.raitingMovie {
    &__container {
        margin: 0 auto;
    }
    &__wrapper {
        display: flex;
        flex-direction: column;
        gap: 20px;
        border-radius: 10px;
        background: #292929;
        padding: 40px;
        &_title {
            display: flex;
            flex-direction: column;
            gap: 10px;
            p {
                color: #fff;
                font-size: 24px;
                font-style: normal;
                font-weight: 600;
                line-height: normal;
            }
            span {
                color: #707070;
                font-size: 14px;
                font-style: normal;
                font-weight: 400;
                line-height: normal;
            }
        }
    }
    .title {
        font-size: 22px;
        font-weight: bold;
        margin-bottom: 15px;
    }
    .rating {
        display: flex;
        flex-direction: column;
        &__wrapper {
            display: flex;
            flex-direction: column;
            gap: 10px;
            width: 100%;
        }
        &__number {
            font-size: 24px;
            font-weight: 700;
        }
        &__list {
            display: flex;
            align-items: center;
            input[type="radio"] {
                appearance: none;
                position: absolute;
                opacity: 0;
            }
            label {
                display: flex;
                justify-content: center;
                align-items: center;
                cursor: pointer;
                position: relative;
                &::before {
                    content: attr(data-i);
                    position: absolute;
                    top: 0;
                    left: 0;
                    right: 0;
                    bottom: 0;
                    font-size: 16px;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    z-index: 1;
                    // will-change: transform;
                    transition: 0.3s ease;
                }
                span {
                    font-size: 10px;
                    padding-top: 2px;
                    color: #fff;
                    position: absolute;
                    inset: 0;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    transition: 0.3s;
                    // will-change: transform;
                }
                svg {
                    width: 47px;
                    height: 47px;
                    transition: 0.3s;
                    color: #393939;
                    position: relative;
                    will-change: transform;
                }

                &:not(:nth-last-child(2)) {
                    margin-right: 10px;
                }
            }
            label:is(:hover, :has(~ :hover)) svg {
                transform: scale3d(1.35, 1.35, 1);
            }
            label:is(:hover, :has(~ :hover))::before {
                transform: scale3d(1.35, 1.35, 1);
            }
            label:is(:hover, :has(~ :hover)) span {
                transform: scale3d(1.35, 1.35, 1);
            }
            label:has(~ :checked) svg {
                color: #ffc700;
                text-shadow: 0 0 2px #ffffff, 0 0 10px #ffee58;
            }
            label:has(~ :checked) span {
                color: #000;
            }
            &.notLoggedIn {
                label:has(~ :checked) svg {
                    color: #393939;
                    text-shadow: none;
                }
            }
        }
        &__swiper {
            display: none;
            width: 100%;
        }
        .el-button {
            display: none;
        }
    }
    .text {
        p {
            font-size: 18px;
            line-height: 1.5;
            opacity: 0.8;
        }
    }
}
.hero {
    &__ratings {
        display: flex;
        gap: 30px;
        flex-wrap: wrap;
        list-style: none;
        &_item {
            display: flex;
            align-items: center;
            gap: 10px;
            &_img {
                width: 30px;
                height: 30px;
                img {
                    width: 100%;
                    height: 100%;
                    border-radius: 5px;
                }
            }
            &_number {
                font-size: 24px;
                font-weight: 600;
            }
        }
    }
}
.unAuthorizeModal {
    position: fixed;
    top: 50%;
    left: 0;
    width: 100%;
    height: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 9999;
    overflow: hidden;
    transition: 0.3s;
    background: rgba(0, 0, 0, 0.5);
    &__wrapper {
        position: relative;
        z-index: 1;
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: 20px;
        background: #262626;
        padding: 30px;
        width: 90%;
        max-width: 500px;
        border-radius: 10px;
        opacity: 0;
        transition: 0.3s ease 0.3s;
        .text {
            font-size: 22px;
            font-weight: bold;
            text-align: center;
        }
        .btns {
            display: flex;
            align-items: center;
            gap: 20px;
            .btn {
                border: none;
                border-radius: 4px;
                display: flex;
                align-items: center;
                justify-content: center;
                gap: 8px;
                padding: 10px 20px;
                font-size: 17px;
                font-weight: 500;
                cursor: pointer;
                transition: 0.2s;
                color: #fff;
                background: #322f2f;
                &.auth {
                    background: #e41a4b;
                }
                &:hover {
                    opacity: 0.7;
                }
            }
        }
    }
    &.open {
        top: 0;
        height: 100%;
        .unAuthorizeModal {
            &__wrapper {
                opacity: 1;
            }
        }
    }
}

.thankForRate {
    position: fixed;
    top: 70px;
    right: 30px;
    background: #000;
    padding: 20px 30px;
    z-index: 9999;
    border-right: 5px solid #e41a4b;
    p {
        color: #fff;
        font-size: 20px;
        font-weight: bold;
    }

    transform: translateX(calc(100% + 30px));
    transition: transform 0.2s ease-in-out;
    &.active {
        transform: translateX(0);
    }
}

// @media (max-width: 800.98px) {
//     .raitingMovie {
//         &__container {
//             width: 100%;
//         }
//     }
// }
@media (max-width: 991.98px) {
    .raitingMovie {
        position: fixed;
        top: 50%;
        left: 0;
        width: 100%;
        height: 0;
        display: flex;
        justify-content: center;
        align-items: center;
        z-index: 9999;
        overflow: hidden;
        transition: 0.3s;
        background: rgba(0, 0, 0, 0.5);
        &__container {
            width: 100%;
        }
        &__wrapper {
            width: 90%;
            max-width: 500px;
            border-radius: 10px;
            opacity: 0;
            transition: 0.3s ease 0.3s;
            flex-direction: column;
        }
        .hero__ratings {
            display: none;
        }
        .rating {
            &__list {
                display: none;
            }
            &__swiper {
                display: block;
                &_list {
                    &_item {
                        width: 50px;
                        height: 50px;
                    }
                }
            }
            .sendButton {
                display: flex;
                height: 58px;
                padding: 0 35px;
                border-radius: 12px;
                display: flex;
                align-items: center;
                justify-content: center;
                gap: 15px;
                font-size: 20px;
                font-weight: 500;
                border: none;
                outline: none;
                background: #e41a4b;
                color: #fff;
                cursor: pointer;
            }
            .el-button{
                display: flex;
            }
        }
        &.open {
            top: 0;
            height: 100%;
            .raitingMovie {
                &__wrapper {
                    opacity: 1;
                }
            }
        }
    }
}
@media (max-width: 768px) {
    .raitingMovie {
        &__wrapper {
            border-radius: 10px;
            background: #292929;
            padding: 20px;
            margin: 0 auto;
            &_title {
                p {
                    font-size: 20px;
                }
            }
        }
        .rating {
            &__list {
                width: 100%;
                label {
                    width: calc(100% / 10);
                    &::before {
                        font-size: 1em;
                    }
                    svg {
                        width: 100%;
                        height: 100%;
                    }

                    &:not(:nth-last-child(2)) {
                        margin-right: 5px;
                    }
                }
                label:is(:hover, :has(~ :hover)) svg {
                    transform: scale(1);
                }
                label:is(:hover, :has(~ :hover))::before {
                    transform: scale(1);
                }
                label:is(:hover, :has(~ :hover)) span {
                    transform: scale(1);
                }
                label:has(~ :checked) svg {
                    color: #ffc700;
                    text-shadow: 0 0 2px #ffffff, 0 0 10px #ffee58;
                }
                label:has(~ :checked) span {
                    color: #000;
                }
            }
        }
    }
    .hero {
        &__ratings {
            &_item {
                gap: 7px;
                &_img {
                    width: 25px;
                    height: 25px;
                    img {
                        border-radius: 5px;
                    }
                }
                &_number {
                    font-size: 16px;
                }
            }
        }
    }
}

@media (max-width: 575.98px) {
    .raitingMovie {
        .rating {
            &__list {
                label {
                    &::before {
                        font-size: 0.8em;
                    }
                }
            }
        }
    }
}
</style>
